/* eslint-disable @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires */

export const IllusRewards = require('./IllusRewards.png');
export const IllusChallenges = require('./IllusChallenges.png');
